import { gql } from '@apollo/client'

export const RATEPLAN_POLICY_QUERY = gql`
  query RatePlanPolicies(
    $accID: String!
    $roomTypeID: String!
    $ratePlanID: String!
  ) {
    ratePlanPolicies(
      accID: $accID
      roomTypeID: $roomTypeID
      ratePlanID: $ratePlanID
    ) {
      from
      to
      policySet {
        id
        description
        name
        policies {
          priority
          penaltyAmount
          deadline
          deadlineTimeOffset
          penaltyType
          policyType
        }
      }
    }
  }
`

export const RATEPLAN_ADD_POLICY_MUTATION = gql`
  mutation AddRatePlanPolicy(
    $input: AddRatePlanPolicyInput!
    $accID: String!
    $roomTypeID: String!
    $ratePlanID: String!
    $providerID: String!
  ) {
    addRatePlanPolicy(
      input: $input
      accID: $accID
      roomTypeID: $roomTypeID
      ratePlanID: $ratePlanID
      providerID: $providerID
    ) {
      message
    }
  }
`
